import { Alert, Anchor, Box, Button, Card, Collapse, Divider, Flex, Grid, Group, Image, Space, Text, Title, Transition } from "@mantine/core";
import { motion, Variants } from "framer-motion";

import image1 from "../assets/base_1.png";
import image2 from "../assets/base_2.png";
import hero_1 from "../assets/themes.mp4";
import stache from "../assets/stache.png";
import icon from "../assets/icon.png";
import DownloadButton from "../components/downloadbutton";
import useVersion from "../hooks/useVersion";
import { FaArrowDown, FaDesktop, FaDownload, FaHeart, FaInfoCircle, FaPatreon, FaReddit, FaTools } from "react-icons/fa";
import { IoArrowUp, IoLogoReddit } from "react-icons/io5";
import DownloadCard from "../components/downloadcard";
import useSetting from "../hooks/useBanner";
import { useWindowScroll } from "@mantine/hooks";
import { useEffect, useState } from "react";



const NewHomepage = () => {
    const [disabledDownloads, setDisabledDownloads] = useState(false);
    const scroll = useWindowScroll();
    const version = useVersion();
    const banner = useSetting("banner");
    const showDonate = useSetting("showDonate");
    const showHeaderButtons = useSetting("showHeaderButtons");
    const disableDownload = useSetting("disableDownload");

    useEffect(() => {
        if (disableDownload === "true") {
            setDisabledDownloads(true);
        } else {
            setDisabledDownloads(false);
        }
    }, [disableDownload]);

      // Feature categories
  const featureCategories = [
    {
      title: "Interface",
      icon: <FaDesktop size="24"/>,
      features: [
        "Modern GUI",
        "Light and Dark Mode Plus Themes for Premium users",
        "Quickly change settings with CTRL+P spotlight",
        "Hotkey shortcuts and \"Pro Mode\" for advanced users"
      ]
    },
    {
      title: "Core Features",
      icon: <FaTools size="24"/>,
      features: [
        "Manage multiple yt-dlp configurations",
        "Automate yt-dlp with Subscriptions",
        "Video Trimming",
        "Custom video and audio players built-in with (Premium feature)",
      ]
    },
    {
      title: "YT-DLP Integration",
      icon: <FaDownload size="24"/>,
      features: [
        "Automated FFMPEG Installation Tool",
        "Automatically keep yt-dlp updated",
        "Manage yt-dlp options via custom configurations",
        "yt-dlp log viewer"
      ]
    },
    {
      title: "Community & Support",
      icon: <FaPatreon size="24"/>,
      features: [
        "Regular release notes, interactive polls, and sneak peeks for Stacher Premium members on Patreon",
        "A growing reddit community at /r/stacherio",
        "No ads. ever. period.",
        "Base application is free, forever. Premium is totally optional!"
      ]
    }
  ];

    const fadeIn: Variants = {
        hidden: { 
            opacity: 0 
        },
        visible: { 
            opacity: 1,
            transition: {
            duration: 0.8
            }
        }
    };

    const fadeInUp: Variants = {
        hidden: { 
            opacity: 0,
            y: 20,
        },
        visible: { 
            opacity: 1,
            y: 0,
            transition: {
            duration: 0.8
            }
        }
    };
    const fadeInDown: Variants = {
        hidden: {
            opacity: 0,
            y: -20,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
            duration: 0.8
            }
        }
    };


    // Intersection observer options
    const viewportOptions = {
    once: false,
    margin: "-100px 0px"
    };


    const renderBanner = () => {
        if (showDonate != "true") {
            return null;
        }
        return (
            <Box
                w="100vw"
                h="35px"
                bg="linear-gradient(90deg, rgba(187, 0, 255, 0.7) 0%, rgba(255, 0, 150, 0.7) 100%)"
                style={{cursor: "pointer"}}
                onClick={() => {
                    window.open("https://license.stacher.io/?donate")
                }}
            >
                <Text
                    c="white"
                    ta="center"
                    fw="bold"
                    style={{ lineHeight: "35px" }}
                >
                    Click here to see how you can Support Stacher! 
                </Text>
            </Box>
        )
    }
    
    const renderHeader = () => {
        return (
            <Grid
                w="100%"
            >
                <Grid.Col span={6}>
                    <Flex
                        direction={"row"}
                        gap="md"
                        align="center"
                        justify={"flex-start"}
                        w="100%"
                    >
                        <Image src={stache} alt="Header Image 1" w="100px"/>
                        <Title order={4} style={{verticalAlign: "middle"}}>stacher.io</Title>
                    </Flex>
                </Grid.Col>
                <Grid.Col span={6}>
                    <Flex
                        direction={"row"}
                        gap="xl"
                        align="center"
                        justify={"flex-end"}
                        w="100%"
                    >
                        <Anchor href="https://www.reddit.com/r/stacherio/" target="_blank" underline="hover" size="sm" visibleFrom="md">
                            Community
                        </Anchor>
                        <Anchor href="https://changelog.stacher.io/" target="_blank" underline="hover" size="sm" visibleFrom="md">
                            Change Log
                        </Anchor>
                        <Anchor href="https://ffmpeg.stacher.io/" target="_blank" underline="hover" size="sm" visibleFrom="md">
                            Manual FFMPEG Installation Guide
                        </Anchor>
                        <Button
                            radius={"xl"}
                            size="xs"
                            onClick={() => {
                                window.open("https://www.patreon.com/14816134/join");
                            }}
                        >
                            Stacher Premium
                        </Button>
                    </Flex>
                </Grid.Col>
            </Grid>
        )
    }

    const renderSectionOne = () => {
        return (
            <Grid
                w="100%"
                mt="md"
                mb="md"
                gutter="md"
            >
                <Grid.Col span={{
                    base: 12,
                    md: 6,
                }}>
                    <Flex
                        direction={"column"}
                        gap="md"
                        align="center"
                        justify={"center"}
                        w="100%"
                        mih={`calc(100vh - 200px)`}
                    >

                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            variants={fadeInDown}
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
                        >
                            <Image src={image1} alt="Header Image 2" w="100%" />
                        </motion.div>
                    </Flex>
                </Grid.Col>
                <Grid.Col span={{
                    base: 12,
                    md: 6,
                }}>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeIn}
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
                    >
                        <Flex h="calc(100vh - 200px)" direction="column" align="flex-start" justify="center" gap="md" w={{
                            base: "100%",
                            md: "80%",
                        }}>
                            <Title order={1}>Stacher 7</Title>
                            <Text size="md">
                                An easy, cross‑platform yt-dlp GUI for Windows, macOS, and Linux. Use Stacher’s Library and custom players for seamless playback, search, filtering, and metadata‑driven organization.
                            </Text>
                            <Space h="10%" />
                            <DownloadButton disabled={disabledDownloads} />
                            <Text size="xs" c="dimmed">
                                Latest release: v{version}. This software relies on third-party tools, yt-dlp and ffmpeg. Stacher does not host or distribute these tools but will provide optional functionality to install and manage them from their official sources.
                            </Text>
                            <Anchor href="#downloads" underline="hover">
                                see all available downloads & checksums here
                            </Anchor>
                        </Flex>
                    </motion.div>
                </Grid.Col>
            </Grid>
        )
    }

    const renderSectionTwo = () => {
        return (
            <Grid
                w="100%"
                mt="md"
                mb="md"
                gutter="md"
            >
                <Grid.Col span={{
                    base: 12,
                    md: 6,
                }}>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeInUp}
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
                    >
                        <Flex h="calc(100vh - 200px)" direction="column" align="flex-start" justify="center" gap="md" w={{
                            base: "100%",
                            md: "80%",
                        }}>
                            <Title order={2}>What is Stacher exactly?</Title>
                            <Text size="md">
                                Stacher is a GUI (Graphical User Interface) for yt-dlp, a powerful command-line tool used to download videos and audio from various online platforms. Stacher simplifies the process of downloading and managing media content by providing an intuitive interface without the need for command-line knowledge or for those who prefer a visual approach. You can read more about yt-dlp <Anchor href="https://github.com/yt-dlp/yt-dlp" target="_blank" underline="hover">here</Anchor>. Customizing yt-dlp arguments is as simple as flipping switches and entering values in Stacher's Settings. 
                            </Text>
                            <Space h="20px" />
                            <Text size="sm" c="dimmed">
                                Stacher is Desktop only and available for Windows, MacOS, and Debian based Linux distributions.
                            </Text>
                            <Space h="20px" />
                            <Button
                                size="sm"
                                variant="outline"
                            >
                                Jump to All available Downloads
                            </Button>
                        </Flex>
                    </motion.div>
                </Grid.Col>
                <Grid.Col span={{
                    base: 12,
                    md: 6,
                }}>
                    <Flex
                        direction={"column"}
                        gap="md"
                        align="center"
                        justify={"center"}
                        w="100%"
                        mih={`calc(100vh - 200px)`}
                    >

                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            variants={fadeInUp}
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
                        >
                            <Image src={image2} alt="Header Image 2" w="100%"/>
                        </motion.div>
                    </Flex>
                </Grid.Col>
            </Grid>
        )
    }

    const renderSectionThree = () => {
        return (
            <Grid
                w="100%"
                mt="md"
                mb="md"
                gutter="md"
            >
                <Grid.Col span={{
                    xs: 12,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 6
                }}>
                    <Flex
                        direction={"column"}
                        gap="md"
                        align="center"
                        justify={"center"}
                        w="100%"
                        mih={`calc(100vh - 200px)`}
                    >

                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            variants={fadeInUp}
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
                        >
                            <video width="80%" height="auto" 
                                controls={false}
                                autoPlay
                                muted
                                loop

                            >
                                <source src={hero_1} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </motion.div>
                    </Flex>
                </Grid.Col>
                <Grid.Col span={{
                    xs: 12,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 6
                }}>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeInUp}
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
                    >
                        <Flex mih="calc(100vh - 200px)" direction="column" align="flex-start" justify="center" gap="md" w={{
                            base: "100%",
                            md: "80%",
                        }}>
                            <Title order={2}>Stacher Premium</Title>
                            <Text size="md">
                                Stacher as a yt-dlp GUI is free and without limitations. However, for users interested in supporting the project and gaining access to exclusive features, Stacher Premium is also available.
                            </Text>
                            <Space h="20px" />
                            <Text size="md">
                                Stacher Premium unlocks additional functionalities like themes, priority support, and Stacher's Library where you can manage media content directly within Stacher. By subscribing to Stacher Premium, users contribute to the ongoing development and maintenance of Stacher, ensuring its continued growth and improvement. 
                            </Text>
                            <Text td="underline" fw="bold">All new installations of Stacher come with a 30 day free trial of Stacher Premium's Library!</Text>
                            <Space h="20px" />
                            <Text size="sm" c="dimmed">
                                <Anchor href="https://license.stacher.io/?donate" target="_blank" underline="hover">                              Learn more about how you can support Stacher and Stacher Premium here</Anchor>
                            </Text>
                        </Flex>
                    </motion.div>
                    
                </Grid.Col>
            </Grid>
        )


    }

    const renderFeaturesSection = () => {
        return (
            <Grid
                w="100%"
                mt="xl"
                mb="md"
                gutter="xl"
                mih={`calc(100vh - 200px)`}
                pl="xl"
                pr="xl"
            >
                <Grid.Col span={12}>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeInUp}
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
                    >
                        <Flex direction="row" align="center" justify="center" mb="md">
                            <Title order={2}>Key Features</Title>
                        </Flex>
                    </motion.div>
                </Grid.Col>

                {featureCategories.map((category, index) => (
                    <Grid.Col span={{
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6
                    }} key={index}>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            variants={fadeInUp}
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}
                        >
                            <Card shadow="sm" padding="lg" radius="md" withBorder
                                w="100%"
                            >
                                <Flex direction="column" gap="sm">
                                    <Flex direction="row" align="center" gap="sm">
                                        {category.icon}
                                        <Title order={4}>{category.title}</Title>
                                    </Flex>
                                    <ul>
                                        {category.features.map((feature, fIndex) => (
                                            <li key={fIndex}>
                                                <Text size="sm">{feature}</Text>
                                            </li>
                                        ))}
                                    </ul>
                                </Flex>
                            </Card>
                        </motion.div>
                    </Grid.Col>
                ))} 
                <Grid.Col span={12}>
                    <Space h="md" />
                </Grid.Col>
                <Grid.Col span={12}>
                    <Text  c="dimmed" ta="center">
                        And much more!
                        <br/>
                        Explore Stacher to discover all its features.
                    </Text>
                </Grid.Col>
            </Grid> 
        )
    }

    const renderDownloadSection = () => {
        return (
            <Grid
                w="100%"
                mt="xl"
                mb="md"
                p="xl"
                gutter="xl"
            >
                <Grid.Col span={12}>
                <motion.section
                    id="downloads"
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOptions}
                >
                <Space h="xl" />
                <motion.div variants={fadeInUp}>
                    <Group
                    align="center"
                    justify="center"
                    style={{
                        gap: "20px",
                        color: "white"
                    }}
                    >
                    <Title order={2} ta="center">All available downloads</Title>
                    <FaArrowDown color="white" size="20px" />
                    </Group>
                </motion.div>
                <Space h="xl" />
                </motion.section>
            </Grid.Col>

            {/* Download Cards */}
            <Grid.Col span={{
                xs: 12,
                sm: 12,
                md: 6,
                lg: 6,
                xl: 6
            }}>
                <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={viewportOptions}
                variants={fadeInUp}
                >
                <DownloadCard type="macsilicon" disabled={disabledDownloads} />
                </motion.div>
            </Grid.Col>
            <Grid.Col span={{
                xs: 12,
                sm: 12,
                md: 6,
                lg: 6,
                xl: 6
            }}>
                <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={viewportOptions}
                variants={fadeInUp}
                >
                <DownloadCard type="macintel" disabled={disabledDownloads} />
                </motion.div>
            </Grid.Col>
            <Grid.Col span={{
                xs: 12,
                sm: 12,
                md: 6,
                lg: 6,
                xl: 6
            }}>
                <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={viewportOptions}
                variants={fadeInUp}
                >
                <DownloadCard type="windows" disabled={disabledDownloads} />
                </motion.div>
            </Grid.Col>
            <Grid.Col span={{
                xs: 12,
                sm: 12,
                md: 6,
                lg: 6,
                xl: 6
            }}>
                <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={viewportOptions}
                variants={fadeInUp}
                >
                <DownloadCard type="linux" disabled={disabledDownloads} />
                </motion.div>
            </Grid.Col>
            <Grid.Col span={12}>
                <Space h="md" />
            </Grid.Col>
            </Grid>
        )
    }


    const renderAlerts = () => {
        if (!banner || banner.trim() === "") {
            return null;
        }
        return (
            <Flex
                w="100%"
                direction="column"
                align="center"
                justify="center"
                gap="md"
                mt="5%"
                mb="-5%"
                pl="xl"
                pr="xl"
            >
                <Alert
                    variant="filled"
                    color="indigo"
                    icon={<FaInfoCircle />}
                    maw="70%"
                >
                    <Text size="sm" fw="bold">
                        <div dangerouslySetInnerHTML={{ __html: banner }} />
                    </Text>
                </Alert>
            </Flex>
        )
    }

    const renderBody= () => {
        return (
            <Flex p="md" w="100%" direction="column" align="flex-start" justify="center">
                {renderHeader()}
                {renderAlerts()}
                {renderSectionOne()}
                {renderSectionTwo()}
                {renderSectionThree()}
                {renderFeaturesSection()}
                {renderDownloadSection()}
            </Flex>
        )
    }

    const renderFooter = () => {
        return (
            <Box
                w="100%"
                // bg="linear-gradient(90deg, rgba(255,0,150,0.7) 0%, rgba(255, 72, 0, 0.7) 100%)"
                mt="xl"
                p="20px"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Flex
                    direction="column"
                    align="center"
                    justify="center"
                    gap="md"
                    maw="1200px"
                >
                    <Flex
                        gap="lg"
                    >
                        <Anchor href="https://github.com/yt-dlp/FFmpeg-Builds#ffmpeg-static-auto-builds" target="_blank" underline="hover" c="dimmed" size="sm">
                            YT-DLP Custom FFMPEG Builds
                        </Anchor>
                        <Divider orientation="vertical" />
                        <Anchor href="https://github.com/yt-dlp/yt-dlp" target="_blank" underline="hover" c="dimmed" size="sm">
                            YT-DLP Documentation
                        </Anchor>
                        <Divider orientation="vertical" />
                        <Anchor href="https://www.reddit.com/r/stacherio/" target="_blank" underline="hover" c="dimmed" size="sm">
                            /r/stacherio
                        </Anchor>
                        <Divider orientation="vertical" />
                        <Anchor href="https://www.reddit.com/r/youtubedl/" target="_blank" underline="hover" c="dimmed" size="sm">
                            /r/youtubedl
                        </Anchor>
                    </Flex>
                    <Space h="md" />
                    <Text
                        c="dimmed"
                        ta="center"
                        size="sm"
                    >
                        Stacher is not affiliated with yt-dlp or FFMPEG. yt-dlp and FFMPEG are third-party tools developed and maintained by their respective communities. Please check the yt-dlp and ffmpeg official websites for more information on these tools.
                        
                    </Text>
                    <Text
                        c="dimmed"
                        ta="center"
                        size="sm"
                        fw="bold"
                    >
                        Thank you all for your support! 
                    </Text>
                    <FaHeart color="#828282" size="16px" />
                    <Text
                        c="dimmed"
                        ta="center"
                        size="xs"
                        w="80%"
                    >
                        © {new Date().getFullYear()} Hexotic Software LLC. All rights reserved.
                        <br/>
                        The Apple logo is a trademark of Apple Inc., registered in the U.S. and other countries. Windows is a registered trademark of Microsoft Corporation in the United States and/or other countries. Ubuntu is a registered trademark of Canonical Ltd. in the U.S. and other countries. All other trademarks are the property of their respective owners.
                        <br/>
                        2.0.1
                    </Text>
                </Flex>
            </Box>
        )
    }

    const renderBackToTopButton = () => {
        return (
            <Transition transition="fade" duration={300} mounted={scroll[0].y >= 300}>
                {(style) => (
                    <Button
                        variant="outline"
                        style={{
                            ...style,
                            position: "fixed",
                            bottom: "20px",
                            right: "20px",
                            zIndex: 1000,
                        }}
                        radius={"xl"}
                        color="gray"
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                    >
                        <IoArrowUp />
                    </Button>
                )}
            </Transition>
        )
    }


    return (
        <Flex p="0" direction="column" align="flex-start" justify="center" style={{overflowX: "hidden"}}>
            {renderBanner()}
            {renderBody()}
            {renderFooter()}
            {renderBackToTopButton()}
        </Flex>
    )
};

export default NewHomepage;